function getCentroid(coords) {
  let x = 0,
    y = 0,
    z = 0;
  coords.forEach(({ lat, long }) => {
    const latRad = (lat * Math.PI) / 180;
    const lonRad = (long * Math.PI) / 180;
    x += Math.cos(latRad) * Math.cos(lonRad);
    y += Math.cos(latRad) * Math.sin(lonRad);
    z += Math.sin(latRad);
  });
  const total = coords.length;
  x /= total;
  y /= total;
  z /= total;
  const lon = Math.atan2(y, x);
  const hyp = Math.sqrt(x * x + y * y);
  const lat = Math.atan2(z, hyp);
  return { lat: (lat * 180) / Math.PI, long: (lon * 180) / Math.PI };
}

export default getCentroid;
